/**
 * What a route shows when something under it throws, instead of React Router's developer page.
 *
 * v0.16.0 met this the hard way: Firefox refused the inbox WebSocket (the CSP did not name the
 * ws origin) by throwing an exception that is not an `Error`, and the default page printed `{}`.
 * The person sees one sentence and a reload button; the line under it says what was thrown, so a
 * screenshot is enough to find the cause.
 */
import type { JSX } from "react";
import { useRouteError } from "react-router";

import { useTranslation } from "@/i18n";
import { ErrorState } from "@/ui/states";

import { describeRouteError } from "./routeErrorText";

export function RouteError(): JSX.Element {
  const { t } = useTranslation();
  const error = useRouteError();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-2 bg-bg px-4">
      <ErrorState
        message={t("app.crash.message")}
        retryLabel={t("app.crash.reload")}
        onRetry={() => {
          window.location.reload();
        }}
      />
      <p className="max-w-xl text-center font-mono text-xs text-ink-subtle">
        {describeRouteError(error)}
      </p>
    </div>
  );
}
